import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=55e65f6a&scoped=true"
import script from "./Menu.vue?vue&type=script&lang=ts"
export * from "./Menu.vue?vue&type=script&lang=ts"
import style0 from "./Menu.vue?vue&type=style&index=0&id=55e65f6a&prod&lang=less&scoped=true"
import style1 from "./Menu.vue?vue&type=style&index=1&id=55e65f6a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e65f6a",
  null
  
)

export default component.exports